import React from 'react'

const Required = () => {
  return <span style={{ color: '#ff3f62' }}>*</span>
}

export default Required
